import { inject } from '@angular/core';
import { CanDeactivateFn, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';

import { BladeService } from '../services/blade.service';
import * as _ from 'lodash';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const CanCloseBladeGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
    const bladeService = inject(BladeService);
    const outlet = _.find(bladeService.outlets, (o: RouterOutlet) => o.component === component);

    if (outlet?.isActivated && component.canDeactivate) {
        return component.canDeactivate();
    }

    return true;
};
